<template>
    <div>
      <a-row :gutter="20">
        <a-col :span="16" class="left-panel">
          <div class="title info-row">
            数据范围选择
          </div>
          <div class="group-title info-row">
            选择表单
          </div>
          <div class="group-title info-row">
            <a-checkbox v-if="!data.id" :indeterminate="form.indeterminate" :checked="form.checkAll" @change="centerCheckChange($event,form)">
              全选
            </a-checkbox>
          </div>
          <a-checkbox-group v-model="form.checkedList" @change="onCenterCheckGroupChange($event,form)" style="width: 100%" class="info-row">
            <a-row >
              <a-col :span="6" v-for="(item,index) in form.dataList" :key="index">
                <a-checkbox :value="item.value" class="one-row row-bottom" >
                  <a-tooltip>
                    <template slot="title">
                      {{item.name + (item.description?"—"+item.description:'')}}
                    </template>
                    {{item.name}}
                  </a-tooltip>
                </a-checkbox>
              </a-col>
            </a-row>
          </a-checkbox-group>
        </a-col>
        <a-col :span="8" class="right-panel">
          <div class="title info-row">
            导出结构配置
          </div>
          <div class=" group-title info-row">
            导出格式：excel
          </div>
          <div class="info-row">
            <a-select
              placeholder="请选择"
              style="width: 100%"
              v-model="formatCheckedExcel.selected"
            >
              <a-select-option :value="item.value" v-for="(item,index) in formatCheckedExcel.dataList" :key="index">{{item.text}}</a-select-option>
            </a-select>
          </div>
          <div class="export-btn" >
            <a-button type="primary" @click="createExportHandle" :loading="loading" v-if="!data.id">导出</a-button>
          </div>
        </a-col>
      </a-row>
    </div>
</template>

<script>
  import manyCheck from '@/utils/components/manyCheck'
  import { getAction,postAction } from '@/api/manage'
  import { CACHE_PROJECT_ID,CACHE_PROJECT_NAME } from '@/constants/project'
  import Vue from 'vue'
  export default {
    name: 'Type3',
    props:{
      data:{
        type:Object,
        default(){
          return {}
        }
      }
    },
    data(){
      return {
        loading:false,
        projectId:Vue.ls.get(CACHE_PROJECT_ID) ||'',
        form:{
          indeterminate:false,
          checkedList:[],
          checkAll:true,
          dataList:[
          ],
        },
        formatCheckedExcel:{
          selected:'1',
          dataList:[
            {text:'每个表单一个sheet',value:'1'},
            {text:'所有表单一个sheet',value:'2'},
          ]
        },
      }
    },
    methods:{
      loadDataView(){
        //回显
        if(this.data.id){
          {
            //   formatConfig:formatConfig,
            if(this.data.format==='1'){
              this.formatCheckedExcel.selected = this.data.formatConfig
            }
          }
          {
            this.form.checkedList = this.data.formConfig.split(',')
          }
        }
      },
      loadData(){
        this.loadDataView()
        // 表单
        getAction('/project/projectForm/listAll',{projectId:this.projectId,status:'1'}).then(res=>{
          if(res.success) {
            const dataList = []
            const checkedList = []
            res.result.forEach(item=>{
              checkedList.push(item.id)
              dataList.push({
                value:item.id,
                name:item.name,
                description:item.description,
              })
            })
            this.form.dataList = dataList
            if(!this.data.id){
              this.form.checkedList = checkedList
            }
          }
        })
      },
      centerCheckChange(e,groupInfo){
        manyCheck.centerCheckChange(e,groupInfo)
      },
      onCenterCheckGroupChange(e,groupInfo,parent){
        manyCheck.onCenterCheckGroupChange(e,groupInfo,parent)
      },
      createExportHandle(){
        const formConfig = this.form.checkedList.join(',');
        if(this.form.checkedList.length === 0){
          return this.$message.warning('请选择表单');
        }

        const format = ''
        let formatConfig = this.formatCheckedExcel.selected;
        const params = {
          formConfig:formConfig,
          formatType:format,
          formatConfig:formatConfig,
          projectId:this.projectId,
          type:'3'
        }
        this.loading = true
        postAction('/export/projectExport/create',params).then(res=>{
          if(res.success){
            this.$emit("back")
            this.$message.success(res.message)
          }else{
            this.$message.success(res.message)
          }
        }).finally(()=>{
          this.loading = false
        })
      }
    }
  }
</script>

<style scoped lang="less">

</style>
<style lang="less">

</style>